$('#input-country, #input-zone').select2({
    minimumResultsForSearch: -1,
    dropdownAutoWidth: 'true',
    width: 'auto'
});